import { OBJECT_TYPE } from 'app/constants'
import { ObjectType } from 'app/store/types'
import moment from 'moment'

// export const DATE_TIME_FORMAT = 'dd/MM/yyyy KK:mm a'

const dateTimeFormatOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: true,
}

// DD MMM YYYY
const DDMMMYYYYDateFormatOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
}

const dateFormater = new Intl.DateTimeFormat(navigator.language, dateTimeFormatOptions)
const DDMMMYYYDateFormatter = new Intl.DateTimeFormat(navigator.language, DDMMMYYYYDateFormatOptions)

export const formatDateTime = (date?: Date | string, defaultValue = '---') => {
  if (!date) {
    return defaultValue
  }
  return dateFormater.format(new Date(date))
}

export const formatDateTimeDDMMMYYYY = (date?: Date | string, defaultValue = '---') => {
  if (!date) {
    return defaultValue
  }
  return DDMMMYYYDateFormatter.format(new Date(date))
}

export const formatDateTimeToRelative = (
  date?: Date | string,
  defaultValue = '---'
) => {
  if (!date) {
    return defaultValue
  }
  return moment(date).startOf('seconds').fromNow()
}

export const formatNumber = (number: number, defaultValue: any) => {
  switch (typeof number) {
    case 'number':
      return number.toLocaleString('en-US')
    case 'string':
      if (number && !isNaN(Number(number))) {
        return Number(number).toLocaleString('en-US')
      }
      return defaultValue
    default:
      return defaultValue
  }
}

export const displayString = (value: string | null, defaultValue: string = '---') => {
  if (!value) {
    return defaultValue
  }
  return value
}

export const getObjectTypeLabel = (type: ObjectType) => {
  switch (type) {
    case 'PROJECT':
      return 'Project'
    case 'MPO_PROJECT':
      return 'MPO Project'
    case 'DATASET':
      return 'Dataset'
    case 'PREDICTOR':
      return 'Predictor'
    case 'FOLDER':
      return 'Folder'
    case OBJECT_TYPE.FILE_STORAGE:
      return 'File Storage'
    default:
      return type
  }
}

export const getFullName = (...names: string[]) => {
  return names.filter((name) => name).join(' ')
}
